import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import Grid from "@material-ui/core/Grid";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import InputLabel from "@material-ui/core/InputLabel";
import LocalBarIcon from "@material-ui/icons/LocalBar";
import Divider from "@material-ui/core/Divider";
import { useStyles } from "./classes";
import * as api from "../../api/index.js";
import { Formik, Form } from "formik";
import { useDispatch } from "react-redux";
import { setRefineSearch } from "../../redux/actions/search";

import Selects from "../Selects/Selects";

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2.3),
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(2),
    top: theme.spacing(2),
    color: theme.palette.grey[500],
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon style={{ width: 17, height: 17 }} />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const RefineSearch = (props) => {
  const classes = useStyles();
  const [finalSelected, setFinalSelected] = React.useState([]);

  const handleAddItem = (items, master) => {
    const allTags = tags
      .filter((tag) => tag.tagMaster.name === master)
      .map((e) => e.name);

    // remove all the tags belongs to this master
    const filtered = finalSelected.filter((e) => !allTags.includes(e));

    setFinalSelected((prev) => [...filtered, ...items]);
  };

  const [open, setOpen] = React.useState(false);
  const [tags, setTags] = useState([]);
  const [initialValues] = useState([""]);
  let dispatch = useDispatch();
  useEffect(() => {
    loadData();
    console.log(props);
    /* eslint-disable */
  }, []);

  const loadData = async () => {
    try {
      const { data } = await api.getTags();
      console.log("Tags***", data);
      setTags(data);
      console.log("tags", tags);
    } catch (error) {
      console.log(error);
    }
  };

  const groupMasterTags = (tags) => {
    if (tags && tags.length) {
      const tagMasterNames = tags.map((tag) => tag.tagMaster.name);
      return [...new Set(tagMasterNames)];
    } else {
      return [];
    }
  };
  const Submit = async (e) => {
    try {
      await props.fetchResults(
        props.lng,
        props.lat,
        props.id,
        props.type,
        finalSelected
      );
      dispatch(
        setRefineSearch({
          coordinates: { lat: props.lat, lng: props.lng },
          id: props.id,
          location: props.location,
          name: props.name,
          type: props.type,
          tags: finalSelected,
        })
      );
      setOpen(false);
      setFinalSelected([]);
      console.log("scucess");
      console.log(finalSelected);
    } catch (error) {
      console.log("fail");
    }

    console.log();
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setFinalSelected([]);
  };
  return (
    <div>
      <Button
        variant="contained"
        className={classes.button}
        onClick={handleClickOpen}
      >
        Refine Search
      </Button>
      <Dialog
        fullWidth={true}
        maxWidth="sm"
        PaperProps={{
          style: {
            borderRadius: 50,
            backgroundColor: "#FFFAF7",
            overflowX: "hidden",
          },
        }}
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alginItem: "center",
            alginSelf: "center",
            overflowY: "hidden",
          }}
        >
          <DialogTitle id="customized-dialog-title" onClose={handleClose}>
            <div
              style={{
                marginTop: 15,
                display: "flex",
                flexDirection: "row",
                justifyContent: "center",
                alignContent: "center",
              }}
            >
              <LocalBarIcon style={{ fontSize: 20, marginTop: 6 }} />
              <Typography
                style={{
                  fontFamily: "Gilroy-Light, serif",
                  fontSize: "1.4rem",
                  fontWeight: 600,
                }}
              >
                &nbsp;Filters
              </Typography>
            </div>
          </DialogTitle>
        </div>
        <Divider />
        <Formik
          initialValues={initialValues}
          onSubmit={Submit}
          enableReinitialize
        >
          {({ isValid, dirty, values }) => {
            return (
              <Form>
                <Grid container spacing={1}>
                  {groupMasterTags(tags).map((master) => (
                    <Grid key={master} item xs={12} sm={6}>
                      <InputLabel
                        style={{
                          marginBottom: 10,
                          marginTop: 30,
                          marginLeft: 30,
                          color: "#000000",
                          fontFamily: "Gilroy-Light, serif",
                          fontWeight: 550,
                        }}
                        id="demo-mutiple-name-label"
                      >
                        {master}
                      </InputLabel>
                      <Selects
                        tags={tags}
                        master={master}
                        setFinalSelected={setFinalSelected}
                        finalSelected={finalSelected}
                        addItem={(item, master) => handleAddItem(item, master)}
                      />
                    </Grid>
                  ))}
                </Grid>

                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alginItem: "center",
                    alginSelf: "center",
                    marginTop: 30,
                    marginBottom: 30,
                  }}
                >
                  <Button
                    variant="contained"
                    className={classes.button}
                    // disabled={!dirty || !isValid}
                    type="submit"
                  >
                    Apply
                  </Button>
                </div>
                <div></div>
              </Form>
            );
          }}
        </Formik>
      </Dialog>
    </div>
  );
};

export default RefineSearch;
